import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import Alert from '@mui/material/Alert';
import SpeciesCatchTable from "../../../components/SpeciesCatch/SpeciesCatchTable";

function CloseForm4({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};

    if (values.catchList.length === 0)
      formErrors.catchList = "The Trip Catch is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
        flexDirection="column"
      >
        <SpeciesCatchTable
          catchList={values.catchList}
          addCatch={values.setCatchList}
          onDelete={values.deleteSpecies}
          handleChange={handleChange("catch")}
          editIdx={values.editIdx}
          startEditing={values.startEditing}
          stopEditing={values.stopEditing}
        />
      </Box>
      {errors.catchList && <Alert severity="error">{errors.catchList}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default CloseForm4;
